var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pageLayout',_vm._l((_vm.imgs),function(img,index){return _c('div',{key:index,staticClass:"image-wrapper"},[_c('img',{attrs:{"src":img}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }